import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import cookies from './module/cookies.js'
import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
import customRellax from './module/customRellax.js';

function functions (deviceData) {
  // console.log(deviceData);
  lenisScroll()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  darkModeOS(cookies)
  animations()
  customRellax()
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
  // if (deviceData.isDesktop === true) pointer()
}

export default functions
